import { defineComponent as _defineComponent } from 'vue'
import type { ThumborOptions } from '@/filters/thumbor';
import type { ModuleTitleFieldsFragment } from '@/features/onboarded-home/graphql/queries/GetHomeModules.query';

import PictureComp from '@/components/picture/PictureComp.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';

import Vue, { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicTitleCardFullImage',
  props: {
    title: null,
    short: { type: Boolean },
    bordered: { type: Boolean },
    grayscale: { type: Boolean },
    backgroundShadow: { type: Boolean, default: true },
    backgroundShadowPosition: { default: 'left' },
    backgroundShadowOverride: null,
    size: { default: 'sm' }
  },
  emits: ['onPosterClick'],
  setup(__props: any) {

const props = __props as { title: ModuleTitleFieldsFragment, short?: boolean, bordered?: boolean, grayscale?: boolean, backgroundShadow: boolean, backgroundShadowPosition: 'left' | 'bottom', backgroundShadowOverride?: string | undefined, size: 'sm' | 'lg' };





const backdropUrl = computed<string | undefined>(() => props.title.content?.backdrops?.[0]?.backdropUrl);
const useBackdrop = computed(() => backdropUrl.value && props.size === 'sm');
const imageProfile = computed(() => (useBackdrop.value ? 'backdrop' : 'poster_global'));
const imgUrl = computed(() =>
	Vue.filter('Thumbor')({
		url: useBackdrop.value ? backdropUrl.value : props.title.content?.posterUrl,
		imageType: imageProfile.value,
	} as ThumborOptions)
);

return { __sfc: true,props, backdropUrl, useBackdrop, imageProfile, imgUrl, PictureComp, TitleDetailLink }
}

})